/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Book_Health_ConsentInputs */

const en_guest_book_health_consent = /** @type {(inputs: Guest_Book_Health_ConsentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I explicitly consent to Complete Athlete and this business processing my answers, which may reveal health information, to arrange and provide this visit. I can withdraw this at any time.`)
};

const pl_guest_book_health_consent = /** @type {(inputs: Guest_Book_Health_ConsentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyrażam wyraźną zgodę na przetwarzanie moich odpowiedzi, które mogą ujawniać informacje o zdrowiu, przez Complete Athlete i tę firmę w celu zorganizowania i przeprowadzenia tej wizyty. Mogę ją wycofać w każdej chwili.`)
};

/**
* | output |
* | --- |
* | "I explicitly consent to Complete Athlete and this business processing my answers, which may reveal health information, to arrange and provide this visit. I c..." |
*
* @param {Guest_Book_Health_ConsentInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const guest_book_health_consent = /** @type {((inputs?: Guest_Book_Health_ConsentInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Book_Health_ConsentInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_guest_book_health_consent(inputs)
	return en_guest_book_health_consent(inputs)
});